import React from 'react';
import { MusicAlbumEntity } from '../../types/MusicAlbumEntityTypes';

/**
 * 修正依頼内容
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function MusicAlbumCorrectionRequestView({
  musicAlbum,
} : {
  musicAlbum: MusicAlbumEntity,
}) {
  return (
    <>
      {musicAlbum.release_status === 5 && (
        <p style={{
          color: 'red', background: '#ff000014', borderRadius: '5px', padding: '20px', marginBottom: '30px', fontSize: '14px',
        }}
        >
            {musicAlbum.correction_request}
        </p>
      )}
    </>
  );
}
